import { render, staticRenderFns } from "./CommitteeGroupList.vue?vue&type=template&id=730e8c18"
import script from "./CommitteeGroupList.vue?vue&type=script&lang=js"
export * from "./CommitteeGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports